export default "__VITE_ASSET__GhMnaArG__"